import {
	BlockControls,
	__experimentalLinkControl as LinkControl,
} from '@wordpress/block-editor';
import { Dropdown, Button } from '@wordpress/components';
import { link } from '@wordpress/icons';
import { __ } from '@wordpress/i18n';

// "link":{
//     "type": "object"
// },

export const VayuBlockLinkBlockControl = ({ value={} , onChange, attributeKey }) => {

	return (
		<BlockControls>
			<Dropdown
				className="th-link-button"
				contentClassName="my-popover-content-classname"
				popoverProps={{ placement: 'bottom-start' }}
				renderToggle={({ isOpen, onToggle }) => (
					<Button
						variant="primary"
						onClick={onToggle}
						aria-expanded={isOpen}
						icon={link}
					></Button>
				)}
				renderContent={() => (
					<LinkControl
						searchInputPlaceholder="Search here..."
						value={value}
						settings={[
							{
								id: 'opensInNewTab',
								title: 'New tab?',
							},
							{
								id: 'marskasnofollow',
								title: 'Mark as nofollow',
							},
						]}
						onChange={(newPost) => onChange(attributeKey, newPost)}
						onRemove={() => onChange(attributeKey, null)}
						withCreateSuggestion={true}
						withURLSuggestion={false}
						createSuggestion={(inputValue) => {
							onChange(attributeKey, {
								...value,
								title: 'admin',
								type: 'custom-url',
								id: Date.now(),
								url: inputValue,
							});
						}}
						suggestionsQuery={{
							type: 'post',
							subtype: 'page',
						}}
						showSuggestions={true}
						showInitialSuggestions={true}
						createSuggestionButtonText={(newValue) =>
							`${__('New:')} ${newValue}`
						}
					/>
				)}
			/>
		</BlockControls>
	);
};